import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"
import { HelloStepUi } from "@src/widgets/onboarding/ui/tours/Welcome/steps/HelloStepUi"

export class HelloStep extends TourStepBase {
  component = HelloStepUi
  name = `${ONBOARDING_TOURS.WELCOME}_HelloStep`

  constructor() {
    super({
      placement: TOUR_MODAL_PLACEMENTS.CENTER,
    })
  }

  action() {
    return Promise.resolve()
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Join our quick tour to explore our product's key features",
      title: "Welcome to Cryptix!",
    }
  }
}
